import { useMemo } from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ErrorFallback = ({ error, resetErrorBoundary }) => {

  const theme = useTheme();

  const buttonTheme = useMemo(() => {
    return {
      color: 'white', backgroundColor: theme.mainColor, fontSize: 15, fontWeight: "bold", borderRadius: 2,
      '&:hover': {
        backgroundColor: '#b30000', color: 'white', fontSize: 15, fontWeight: "bold", borderRadius: 2
      },
    }
  }, [theme.mainColor]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="80vh"
      sx={{
        p: 4
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Something went wrong...
        </Typography>
        <Stack direction="row" spacing={2}>
          <Button sx={{ ...buttonTheme }} href='/'>
            HomePage
          </Button>
          <Button onClick={() => resetErrorBoundary()} sx={{ ...buttonTheme }} >
            Try Again
          </Button>
        </Stack>
      </Box>
    </Box>
  );
}

export default ErrorFallback;
